import React, { useCallback, useContext, useEffect, useState } from "react";
import {GoogleMap, MarkerF, useJsApiLoader,} from "@react-google-maps/api";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faMapLocationDot, faPhone, faPlugCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { UserContext } from "../../context/UserContext";
import Conversor from "../../../helper/Conversor";
import "./style.scss";

const containerStyle = {
    width: "100%",
    height: "100%",
};

const options = {
    gestureHandling: "greedy",
    clickableIcons: false,
    streetViewControl: false,
    fullscreenControlOptions: false,
    mapTypeControl: false,
    styles: [
        { elementType: "labels", featureType: "poi.business", stylers: [{ visibility: "off" }] },
    ],
};

const MapUsers = () => {
    const { selectedStore } = useContext(UserContext);
    // eslint-disable-next-line no-unused-vars
    const [selectedDriver, setSelectedDriver] = useState(null);
    const storeLocation = useState({ lat: selectedStore.address.location.coordinates[0], lng: selectedStore.address.location.coordinates[1] });
    const [drivers, setDrivers] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [map, setMap] = useState(null);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_MAPS_APP_KEY || "",
    });

    useEffect(() => {
        document.title = `Entregadores Online | Motum`;
    });

    const onUnmount = useCallback(() => {
        setMap(null);
    }, []);

    const handleDriverClick = (driver) => {
        setSelectedDriver(driver);
        if (map) {
            map.panTo(driver.deviceLocation); // Centraliza o mapa
            map.setZoom(17); // Zoom opcional
        }
    };

    const fetchDrivers = async () => {
        try {
            if (!storeLocation) return;
            const res = await axios.get(`${process.env.REACT_APP_DELIVERIES_API}/driver/get_online_deliverymans/${selectedStore._id}` , {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            setLoading(true);
            setDrivers(res.data);
            setError(null);
        } catch (err) {
            setLoading(true);
            setError(err.response?.data?.message || "Erro ao buscar localização.");
            setDrivers([]);
        }
    };

    useEffect(() => {
        if (!loading) fetchDrivers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);

    if (!isLoaded) return <div className="tracking-container"><p>Carregando mapa...</p></div>;
    if (error) return <div className="tracking-container"><FontAwesomeIcon icon={faPlugCircleXmark} /><p>{error}</p></div>;

    return (
        <div className="tracking-container">
            <div className="drivers-list">
                <div className="title"><FontAwesomeIcon icon={faMapLocationDot} /> Entregadores Online <FontAwesomeIcon icon={faArrowsRotate} onClick={fetchDrivers} style={{ cursor: 'pointer' }} /></div>
                <ul className="list">
                    {drivers.map((driver) => (
                        <li
                            className="driver-item"
                            key={driver.deliveryman._id}
                            onClick={() => handleDriverClick(driver)}
                        >
                            <div className="driver-details">
                                <div className="name">{driver.deliveryman.name.split(' ')[0] + " " + driver.deliveryman.name.split(' ')[1]}</div>
                                <div className="phone"><FontAwesomeIcon icon={faPhone} /> {Conversor.converterFormatoTelefone(String(driver.deliveryman.cellNumber))}</div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="map-container">
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={storeLocation[0]}
                    zoom={13}
                    onUnmount={onUnmount}
                    onLoad={(map) => setMap(map)}
                    options={options}
                >
                    <MarkerF
                        position={storeLocation[0]}
                        title="Loja"
                        icon={{ url: '/shop_location_pin.svg' }}
                    />
                    {drivers.map((driver) => (
                        <MarkerF
                            position={driver.deviceLocation}
                            title={driver.deliveryman.name}
                            icon={{ url: '/motorcycle_map.svg', scaledSize: new window.google.maps.Size(40, 40) }}
                        />
                    ))}
                </GoogleMap>
            </div>
        </div>
    );
};

export default MapUsers;
